import React, { useRef, useState } from "react";
import { Stripe } from "./stripe";
import { apiBasic } from "../api/requests";

export const LocalPaymentForm = ({ callback }) => {
  const [outcome, setOutcome] = useState("approved");
  const [busy, setBusy] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [error, setError] = useState("");
  const pending = useRef(false);
  const order = useRef(null);
  const submit = async (event) => {
    event.preventDefault();
    if (pending.current || confirmed) return;
    pending.current = true;
    setBusy(true);
    setError("");
    try {
      order.current = await callback();
      const data = order.current;
      if (!data?.orderId) throw new Error("No se pudo preparar el pedido para pagar.");
      const response = await apiBasic({ orderId: data.orderId, outcome }, "local-simulated-payment", "post");
      if (response?.error !== false || response.data?.simulated !== true || response.data?.paymentStatus !== "paid" || response.data?.orderId !== data.orderId) {
        throw new Error(response?.message || "No se pudo confirmar el pago local.");
      }
      setConfirmed(true);
      data.functionCallback({ ...data.data, ...response.data }, "paid");
    } catch (failure) {
      setError(failure.message || "No se pudo confirmar el pago local.");
      order.current?.cancelLoading?.();
    } finally {
      pending.current = false;
      setBusy(false);
    }
  };
  return <form onSubmit={submit} aria-label="Pasarela simulada local">
    <p>Simulación local · Sin cobros externos</p>
    <label>Resultado de la simulación <select aria-label="Resultado de la simulación" value={outcome} onChange={event => setOutcome(event.target.value)} disabled={busy}>
      <option value="approved">Pago aprobado</option><option value="rejected">Pago rechazado</option><option value="unavailable">Pasarela no disponible</option>
    </select></label>
    <button type="submit" disabled={busy || confirmed}>{busy ? "Procesando…" : "Pagar"}</button>
    {busy && <p role="status">Confirmando pago local…</p>}
    {confirmed && <p role="status">Pago simulado confirmado.</p>}
    {error && <p role="alert">{error}</p>}
  </form>;
};
export const PaymentGateway = (props) => process.env.REACT_APP_LOCAL_PAYMENT_GATEWAY === "true" && window.location.hostname.endsWith(".localhost")
  ? <LocalPaymentForm {...props} /> : <Stripe {...props} />;
